import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BubbleCharts } from "../../../../Constant";
import Chart from "react-apexcharts";
import { BUBBLE_CHART } from "../../../../Data/Charts/ApexChart";

const BubbleChart = () => {
  return (
    <Col sm="12" xl="6" className="box-col-12">
      <Card>
        <CommonCardHeader title={BubbleCharts} />
        <CardBody>
          <div id="chart-bubble">
            <Chart options={BUBBLE_CHART} series={BUBBLE_CHART.series} type="bubble" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BubbleChart;
